var list = [
    {
        value: 'ZGB',
        text: '中国银行'
    },
    {
        value: 'ZSB',
        text: '招商银行'
    },
    {
        value: 'ZGGSB',
        text: '中国工商银行'
    },
    {
        value: 'ZGJHB',
        text: '中国建设银行'
    },
    {
        value: 'ZGNYB',
        text: '中国农业银行'
    },
    {
        value: 'ZGYZB',
        text: '中国邮政储蓄银行'
    },
    {
        value: 'JCB',
        text: '交通银行'
    },
    {
        value: 'PAB',
        text: '平安银行'
    },
    {
        value: 'PFB',
        text: '浦发银行'
    },
    {
        value: 'ZGMSB',
        text: '中国民生银行'
    }, 
    {
        value: 'ZGGDB',
        text: '中国光大银行'
    },
    {
        value: 'GXB',
        text: '中信银行'
    },
    {
        value: 'HEBB',
        text: '哈尔滨银行'
    },
    {
        value: 'YKB',
        text: '营口银行'
    },
    {
        value: 'DLB',
        text: '大连银行'
    },
    {
        value: 'GZB',
        text: '贵阳银行'
    },
    {
        value: 'HZWSB',
        text: '亳州市徽商银行'
    },
    {
        value: 'HZYDNSB',
        text: '亳洲市药都农村商业银行'
    },
    {
        value: 'DLNS',
        text: '大连农商银行'
    },
    {
        value: 'GZBJCS',
        text: '贵州毕节农村商业银行'
    },
    {
        value: 'GZHZCS',
        text: '贵州赫章农村商业银行'
    },
    {
        value: 'GZNCB',
        text: '贵州省农村信用社合作社'
    },
    {
        value: 'HEBNSB',
        text: '哈尔滨农村商业银行'
    },
    {
        value: 'HLJNSB',
        text: '黑龙江农村信用社'
    },
    {
        value: 'QLB',
        text: '齐鲁银行'
    },
    {
        value: 'SDYCNSB',
        text: '山东润昌农商银行'
    },
    {
        value: 'SXFSNSB',
        text: '山西繁峙农村商业银行'
    },
    {
        value: 'SXNSB',
        text: '山西省农村信用社'
    },
    {
        value: 'SJB',
        text: '盛京银行'
    },
    {
        value: 'SCNXB',
        text: '四川农信'
    },
    {
        value: 'WZB',
        text: '温州银行'
    },
    {
        value: 'WYNSB',
        text: '武义农商银行'
    },
    {
        value: 'XSNSB',
        text: '萧山农商银行'
    },
    {
        value: 'XYB',
        text: '兴业银行'
    },
    {
        value: 'YTNSB',
        text: '烟台农商银行'
    },
    {
        value: 'YNDLNSB',
        text: '云南省大理市农村商业银行'
    },
    {
        value: 'ZJQZNSB',
        text: '浙江省衢州市农村商业银行'
    },
    {
        value: 'ZJTHNSB',
        text: '浙江桐庐农村商业银行'
    },
    {
        value: 'ZJZSDHHYSYB',
        text: '浙江舟山定海海洋农村商业银行'
    },
    {
        value: 'ZJZSDHHYNS',
        text: '浙江舟山定海海洋农商银行'
    },
    {
        value: 'ZJZSPTNS',
        text: '浙江舟山普陀农村商业银行'
    },
    {
        value: 'ZSPTNSB',
        text: '舟山普陀农村合作银行'
    }
];

// function getBank(){
//     return list;
// }

module.exports = {
    list
}